<template>
  <div class="container">

    <div class="columns is-mobile">

        
        <div class="column">
          <div>
            <h1 class="method-title">方法A：人數預估法</h1>
            <b-field label="粉絲人數">
                <b-input v-model="numOfUsers" rounded icon="user" type="number" min="0" placeholder="請輸入官方帳號的粉絲人數"></b-input>
            </b-field>
            <b-field label="預計每人推播訊息數">
                <b-input v-model="numOfPush" rounded type="number" min="0" placeholder="請輸入本月預計要推幾次訊息"></b-input>
            </b-field>
          </div>    
        </div>
        
        <div class="column" style="border-left: 2px dotted #00b800;">
          <h1 class="method-title">方法B：總訊息預估法</h1>
            <b-field label="每月訊息總數">
                <b-input v-model="numOfTotalMsg" rounded type="number" min="0" placeholder="請輸入預計發送的訊息總數"></b-input>
            </b-field>
        </div>
    </div>
    <hr>

    <div class="columns" v-if="bestChoice">
        <div class="column">
          <div class="card" :class="{'bestChoice': bestChoice == 'low'}">
            <div class="card-content">
              <div class="media">
                <div class="media-left">
                  <figure class="image is-48x48">
                    <b-icon v-if="bestChoice == 'low'" icon="check" size="is-large" type="is-success"></b-icon>
                    <b-icon v-else icon="minus-circle" size="is-large"></b-icon>
                  </figure>
                </div>
                <div class="media-content">
                  <p class="title is-2">低用量</p>
                </div>
              </div>

              <div class="content">
                <p>免費訊息數量：{{pricingSetting.low.freeQuota　| numeral('0,0')}}則</p>
                <p>每則加購費用：不可加購</p>
                <p>&nbsp;</p>
                <b-table :data="lowPriceData" :columns="columns"></b-table>
              </div>
            </div>
          </div>
        </div>

        <div class="column">
          <div class="card" :class="{'bestChoice': bestChoice == 'medium'}">
            <div class="card-content">
              <div class="media">
                <div class="media-left">
                  <figure class="image is-48x48">
                    <b-icon v-if="bestChoice == 'medium'" icon="check" size="is-large" type="is-success"></b-icon>
                    <b-icon v-else icon="minus-circle" size="is-large"></b-icon>
                  </figure>
                </div>
                <div class="media-content">
                  <p class="title is-2">中用量</p>
                </div>
              </div>

              <div class="content">
                
                <p>免費訊息數量：{{pricingSetting.medium.freeQuota | numeral('0,0') }}則</p>
                <p>每則訊息費用：{{pricingSetting.medium.addictionPrice}}元</p>
                <p>&nbsp;</p>
                <b-table :data="mediumPriceData" :columns="columns"></b-table>
              </div>
            </div>
          </div>
        </div>

        <div class="column">
          <div class="card" :class="{'bestChoice': bestChoice == 'high'}">
            <div class="card-content">
              <div class="media">
                <div class="media-left">
                  <figure class="image is-48x48">
                    <b-icon v-if="bestChoice == 'high'" icon="check" size="is-large" type="is-success"></b-icon>
                    <b-icon v-else icon="minus-circle" size="is-large"></b-icon>
                  </figure>
                </div>
                <div class="media-content">
                  <p class="title is-2">高用量</p>
                </div>
              </div>

              <div class="content">
                <p>免費訊息數量：{{pricingSetting.high.freeQuota　| numeral('0,0')}}則</p>
                <p>每則加購費用：0.15~</p>
                <p>(依級距調整)</p>
                <b-table :data="highPriceData" :columns="columns"></b-table>
              </div>
            </div>
          </div>
        </div>

    </div>

    <section v-if="bestChoice" class="hero is-success">
      <div class="hero-body">
        <div v-if="bestChoice != 'low'" class="container">
          <h1 class="title">
            預估花費(含稅)：{{bestPrice | numeral('0,0')}}
          </h1>
          <h2 class="subtitle">
            相較其他方案，選擇『{{bestPlanName}}』方案，可以省下　{{ bestSave | numeral('0,0')}}
          </h2>
          <!-- <p>想要省更多？</p> -->
          <a class="button  is-inverted is-outlined is-medium" href="https://lychee.tw/nice-push.html?utm_source=calculator" target="_blank">想要省更多？試試荔枝好推</a>
          <br>

        </div>
      </div>
    </section>

    <!-- <div>
      <button class="button is-primary">
        GO
      </button>
    </div> -->
    <!-- <resource-credits></resource-credits> -->
    <br><br><br>
    <button @click="creditActive = true" class="button is-text is-pulled-right">
      其他
    </button>

    <a class="button is-text is-pulled-right" target="_blank" href="https://bit.ly/2VXt1y4">
      有話想說
    </a>

    <b-modal :active.sync="creditActive">
      <div class="card">
        <div class="card-content">

            <div class="content">
              <h4>資料來源</h4>
              計費標準參照Line官方部落格
              <a href="http://at-blog.line.me/tw/archives/LINEOA2.0.html">http://at-blog.line.me/</a>
            </div>

            <div class="content">
                <h4>credits</h4>
                Icons made by
              <a href="https://www.freepik.com/" title="Freepik" target="_blank">Freepik</a> from
              <a href="https://www.flaticon.com/" title="Flaticon" target="_blank">www.flaticon.com</a> is licensed by
              <a
                href="http://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0"
                target="_blank"
              >CC 3.0 BY</a>
            </div>
        </div>
      </div>
    </b-modal>
    

    

  </div>
</template>

<script>

import {PricingTable, PricingSetting} from './pricingTable.js'

export default {
  name: 'PricingCalculator',
  data () {
    return {
      pricingTable: PricingTable,
      pricingSetting: PricingSetting,
      pricingData: {},
      numOfUsers: null,
      numOfPush: null,
      numOfTotalMsg: null,
      lowPrice: 0,
      mediumPrice: 0,
      highPrice: 0,
      bestChoice: "",
      bestPlanName: "",
      bestPrice: 0,
      bestSave: 0,
      lowPriceData: [
          { 'type': "固定月費", 'amount': PricingSetting.low.basicPrice},
          { 'type': "訊息加購費", 'amount': this.lowPrice},
          { 'type': "小計(未稅)", 'amount': PricingSetting.low.basicPrice},
          { 'type': "含稅價", 'amount': PricingSetting.low.basicPrice},
      ],
      columns: [
          {
              field: 'type',
              label: '類別',
          },
          {
              field: 'amount',
              label: '金額',
              numeric: true
          },
      ],
      creditActive: false,
    }
  },
  computed: {
    // numOfTotalMsg: {
    //   get () {
    //     if (this.numOfUsers == null || this.numOfPush == null) {
    //       return 0
    //     }
    //     return this.numOfUsers * this.numOfPush
    //   },
    //   set (value) {
    //     if (this.numOfUsers > 0) {
    //       this.numOfPush = value / this.numOfUsers
    //     } 
        
    //   }
    // }
  },
  watch: { 
    numOfTotalMsg: function(value) {
      this.getPricing()
    },
    numOfUsers: function(value) {
      this.numOfTotalMsg = value * this.numOfPush
    },
    numOfPush: function (value) {
      this.numOfTotalMsg = this.numOfUsers * value
    }
  },
  methods: {

    getPricing: function () {
      // console.log('getPricing');
      
      this.mediumPrice = this.getMediumMsgPrice();
      this.highPrice = this.getHighMsgPrice();

      if (this.numOfTotalMsg <= 500) {
        this.bestChoice = 'low'
      } else {
        let highTotalPrice = (PricingSetting.high.basicPrice + this.highPrice) * 1.05
        let mediumTotalPrice = (PricingSetting.medium.basicPrice + this.mediumPrice) * 1.05
        if (highTotalPrice < mediumTotalPrice) {
          this.bestChoice = 'high';
          this.bestPlanName = "高用量"
          this.bestPrice = highTotalPrice;
          this.bestSave = mediumTotalPrice - highTotalPrice;
        } else {
          this.bestChoice = 'medium';
          this.bestPlanName = "中用量"
          this.bestPrice = mediumTotalPrice;
          this.bestSave = highTotalPrice - mediumTotalPrice;
        }
      }

      this.mediumPriceData = [
          { 'type': "固定月費", 'amount': numeral(PricingSetting.medium.basicPrice).format('0,0')},
          { 'type': "訊息加購費", 'amount': numeral(this.mediumPrice).format('0,0') },
          { 'type': "小計(未稅)", 'amount': numeral(PricingSetting.medium.basicPrice + this.mediumPrice).format('0,0') },
          { 'type': "含稅價", 'amount': numeral((PricingSetting.medium.basicPrice + this.mediumPrice) * 1.05).format('0,0') },
      ]

      this.highPriceData = [
          { 'type': "固定月費", 'amount': numeral(PricingSetting.high.basicPrice).format('0,0')　},
          { 'type': "訊息加購費", 'amount':  numeral(this.highPrice).format('0,0')},
          { 'type': "小計(未稅)", 'amount': numeral(PricingSetting.high.basicPrice + this.highPrice).format('0,0')　},
          { 'type': "含稅價", 'amount': numeral((PricingSetting.high.basicPrice + this.highPrice) * 1.05).format('0,0') },
      ]

    },

    getMediumMsgPrice: function () {
      if (this.numOfTotalMsg <= 4000) {
        return 0
      } else {
        let amount = this.numOfTotalMsg - 4000
        return amount * 0.2
      }
    },

    getHighMsgPrice: function () {
      // console.log(this.numOfTotalMsg)
      let tier = 0;
      let price = 0;
      if (this.numOfTotalMsg <= PricingSetting.high.freeQuota) {
        return price
      }
      let numOfRemaining = this.numOfTotalMsg;
      numOfRemaining -= PricingSetting.high.freeQuota;

      while (numOfRemaining > 0) {
        // console.log("tier: " + tier + ", remaing: " + numOfRemaining);
        // console.log(numOfRemaining)
        let numOfConsumed = 0

        if (numOfRemaining - this.pricingTable[tier][0] <= 0){
          numOfConsumed = numOfRemaining;
          numOfRemaining = numOfRemaining - this.pricingTable[tier][0]
        } else {
          numOfConsumed = this.pricingTable[tier][0]
          numOfRemaining = numOfRemaining - this.pricingTable[tier][0]
        }
        // console.log(numOfConsumed);
        // console.log(this.pricingTable[tier][1]);

        price += numOfConsumed * this.pricingTable[tier][1]
        tier += 1
        if (tier > PricingSetting.high.tiers) {
          // console.log('over!!')
          // console.log("numOfRemaining: " + numOfRemaining)
          // console.log("additional price: " + numOfRemaining * PricingSetting.high.addictionTop)
          price += numOfRemaining * PricingSetting.high.addictionTop;
          break;
        }
        // console.log('current Price: ' + price)
      }
      return price
    },
 
  },
  mounted: function() {
     console.log(this.$route.query)
     if (this.$route.query.users) {
       this.numOfUsers = this.$route.query.users;
     }

     if (this.$route.query.push) {
       this.numOfPush = this.$route.query.push;
     }
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}

.method-title {
  color: #686868;
  font-size: 2rem;
  line-height: 1.125;

}

.method-border {
    border-width: 1.5px;
    border-style: dashed;
    border-color: #00b800;
    color: #363636;
}

.bestChoice {
  border-width: 3px;
  border-style: dashed;
  border-color: #00b800;
  color: #363636;

  background: #00b8004d !important;
  overflow: hidden;
  height: 100%;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/PricingCalculator.vue